// External libraries
import React from 'react';
import { Button, FieldError } from '@checkout/react-components';
import { useStoreActions, useStoreState } from '@/store';

// Internal modules
import {
  ButtonValue,
  DiscountOrFeeLabel,
  selectInstallmentButtonStyleOverrides,
  TotalLabel,
} from './styles';
import {
  logFPTIWhenDropdownClicked,
  logFPTIWhenDropdownClickedWithIC2B,
} from './fpti';
import {
  getDiscountOrConsumerFeeLabel,
  getInstallmentButtonLabel,
} from './utils';
import { features, getContent } from '@/lib';

const InstallmentButton = () => {
  const installmentTerm = useStoreState(({ form }) => form.installmentTerm);
  const installmentData = useStoreState(({ api }) => api.installmentData);
  const setIsInstallmentInterstitialShown = useStoreActions(
    ({ ui }) => ui.setIsInstallmentInterstitialShown,
  );
  const shouldShowIC2B = features.isActive('shouldShowInstallmentCostToBuyer');

  const { displayError, error, value: term } = installmentTerm;
  const selectedInstallment = installmentData.find(
    option => option.term === term,
  );

  const TotalContent = (
    <TotalLabel data-testid="total-label">
      {getContent('installments.totalAmountContent', {
        totalAmount:
          selectedInstallment?.totalCost?.currencyFormatSymbolISOCurrency,
      })}
    </TotalLabel>
  );

  return (
    <div data-testid="installment-button">
      <Button
        id="installment"
        onClick={() => {
          shouldShowIC2B
            ? logFPTIWhenDropdownClickedWithIC2B(installmentData)
            : logFPTIWhenDropdownClicked();
          setIsInstallmentInterstitialShown(true);
        }}
        styleOverrides={selectInstallmentButtonStyleOverrides(
          displayError,
          selectedInstallment ? 1 : 0,
        )}
      >
        <div>
          <ButtonValue isSelected={!!selectedInstallment}>
            {getInstallmentButtonLabel({
              selectedInstallment,
              shouldShowIC2B,
              term,
            })}
            {shouldShowIC2B && (
              <DiscountOrFeeLabel>
                {getDiscountOrConsumerFeeLabel(selectedInstallment)}
              </DiscountOrFeeLabel>
            )}
          </ButtonValue>
          {selectedInstallment && (
            <label>{getContent('installments.installmentPlan')}</label>
          )}
        </div>
      </Button>
      {shouldShowIC2B && selectedInstallment && TotalContent}
      {displayError && <FieldError>{error}</FieldError>}
    </div>
  );
};

export { InstallmentButton };
